import type { Broker } from '../types';

const negativeUsdcDemoAccount: Broker['accounts'][number] = {
  accountId: '0x_mock_negative_usdc',
  name: 'Negative USDC demo',
  type: 'main',
  positions: [],
  pendingOrders: [],
  holdings: [
    { token: 'USDC', holding: -335.796174, frozen: 0 },
    { token: 'SOL', holding: 3.5, frozen: 0 },
    { token: 'ETH', holding: 0.08, frozen: 0 },
    { token: 'BNB', holding: 0.2, frozen: 0 },
  ],
  totalAssets: 594,
  usdcBalance: -335.796174,
  unsettledPnl: 0,
};

const baseMockBrokers: Broker[] = [
  {
    id: 'broker-woofi',
    name: 'WOOFi Pro',
    accounts: [
      {
        accountId: '0x_mock_main_001',
        name: 'Main account',
        type: 'main',
        positions: [
          { symbol: 'PERP_BTC_USDC', marginMode: 'CROSS', side: 'Long', quantity: 0.5, accountId: '0x_mock', avgOpenPrice: 82000, markPrice: 84500, unrealizedPnl: 1250, unrealizedRoi: 0.0305 },
          { symbol: 'PERP_ETH_USDC', marginMode: 'CROSS', side: 'Long', quantity: 5, accountId: '0x_mock', avgOpenPrice: 3200, markPrice: 3350, unrealizedPnl: 750, unrealizedRoi: 0.0469 },
          { symbol: 'PERP_SOL_USDC', marginMode: 'ISOLATED', side: 'Short', quantity: 100, accountId: '0x_mock', avgOpenPrice: 145, markPrice: 138, unrealizedPnl: 700, unrealizedRoi: 0.0483 },
        ],
        pendingOrders: [
          { id: 'ord-001', symbol: 'PERP_BTC_USDC', side: 'Long', price: 80000, quantity: 0.2, type: 'Limit' },
          { id: 'ord-002', symbol: 'PERP_ETH_USDC', side: 'Short', price: 3500, quantity: 3, type: 'Limit' },
        ],
        holdings: [
          { token: 'USDC', holding: 22500, frozen: 0 },
          { token: 'BNB', holding: 1.5, frozen: 0 },
        ],
        totalAssets: 50000,
        usdcBalance: 22500,
        unsettledPnl: 2700,
      },
      {
        accountId: '0x_mock_sub_001',
        name: 'Sub-account A',
        type: 'sub',
        positions: [
          { symbol: 'PERP_ARB_USDC', marginMode: 'CROSS', side: 'Long', quantity: 5000, accountId: '0x_mock', avgOpenPrice: 1.05, markPrice: 0.98, unrealizedPnl: -350, unrealizedRoi: -0.0667 },
          { symbol: 'PERP_OP_USDC', marginMode: 'CROSS', side: 'Short', quantity: 2000, accountId: '0x_mock', avgOpenPrice: 2.1, markPrice: 2.25, unrealizedPnl: -300, unrealizedRoi: -0.0714 },
        ],
        pendingOrders: [
          { id: 'ord-003', symbol: 'PERP_ARB_USDC', side: 'Long', price: 0.90, quantity: 3000, type: 'Limit' },
        ],
        holdings: [
          { token: 'USDC', holding: 8500, frozen: 0 },
        ],
        totalAssets: 20000,
        usdcBalance: 8500,
        unsettledPnl: -650,
      },
      {
        accountId: '0x_mock_sub_002',
        name: 'Sub-account B',
        type: 'sub',
        positions: [
          { symbol: 'PERP_DOGE_USDC', marginMode: 'CROSS', side: 'Short', quantity: 50000, accountId: '0x_mock', avgOpenPrice: 0.18, markPrice: 0.165, unrealizedPnl: 750, unrealizedRoi: 0.0833 },
          { symbol: 'PERP_LINK_USDC', marginMode: 'CROSS', side: 'Short', quantity: 500, accountId: '0x_mock', avgOpenPrice: 16.5, markPrice: 17.2, unrealizedPnl: -350, unrealizedRoi: -0.0424 },
        ],
        pendingOrders: [],
        holdings: [
          { token: 'USDC', holding: 6200, frozen: 0 },
        ],
        totalAssets: 15000,
        usdcBalance: 6200,
        unsettledPnl: 400,
      },
    ],
  },
  {
    id: 'broker-logx',
    name: 'LogX',
    accounts: [
      {
        accountId: '0x_mock_main_002',
        name: 'Main account',
        type: 'main',
        positions: [
          { symbol: 'PERP_BTC_USDC', marginMode: 'CROSS', side: 'Short', quantity: 0.3, accountId: '0x_mock', avgOpenPrice: 85000, markPrice: 84500, unrealizedPnl: 150, unrealizedRoi: 0.0059 },
        ],
        pendingOrders: [],
        holdings: [
          { token: 'USDC', holding: 18000, frozen: 0 },
        ],
        totalAssets: 30000,
        usdcBalance: 18000,
        unsettledPnl: 150,
      },
    ],
  },
];

export function getMockBrokers(scenario?: string): Broker[] {
  const brokers = baseMockBrokers.map((broker) => ({
    ...broker,
    accounts: [...broker.accounts],
  }));

  if (scenario === 'negative-usdc') {
    return brokers.map((broker) => (
      broker.id === 'broker-woofi'
        ? { ...broker, accounts: [...broker.accounts, negativeUsdcDemoAccount] }
        : broker
    ));
  }

  return brokers;
}

export const mockBrokers: Broker[] = getMockBrokers();
